<aside class="sidenav">
    <mat-toolbar class="toolbar-top">
        <div class="toolbar-top-container">

            <div class="logo">
                <button id="btn-toggle-icon" class="sidenav-toggle" mat-icon-button (click)="isExpanded = !isExpanded">
                    <mat-icon id="toggle-icon" class="text-black">reorder</mat-icon>
                </button>
                <img style="height: 50px; margin-left: 20px;" class="ml-5" src="./assets/img/logo.png" alt="LOGO" />
            </div>
            <div class="d-none d-md-block">
                <h4 style="color: #5B25B4">
                    <mat-icon style="margin-right: 15px; margin-top: 10px;">dashboard</mat-icon>
                    <span style="color: #5B25B4; font-size: 24px; font-weight: bold">Dashboard</span></h4>
            </div>
            <div class="toggler" >
                <mat-menu #userProfile>

                </mat-menu>
            </div>
        </div>
    </mat-toolbar>
    <mat-sidenav-container class="sidenav-container" autosize>
        <mat-sidenav class="mat-sidenav" [position]="'start'" [mode]="mode" #sidenav
                     [opened]="isExpanded">
            <app-sidenav (clicked)="isExpanded = false" [isExpanded]="isExpanded"></app-sidenav>
        </mat-sidenav>
        <mat-sidenav-content class="grey-background">

            <div class="container-fluid main-body">
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</aside>
